import { render, staticRenderFns } from "./CategoriasInstituicoes.vue?vue&type=template&id=cc437f6a"
import script from "./CategoriasInstituicoes.vue?vue&type=script&lang=js"
export * from "./CategoriasInstituicoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports